$(function () {
    $('[data-input-info]').each(function() {
        var $el = $(this);
        var $target = $('#' + $el.data('inputInfo'));
        $el.on('click', function () {
            $el.toggleClass('is-active');
            $target.toggleClass('is-active');
        });
    });
});